import React from "react";
import Hero from "./Hero";
import Service from "./Service";
import Experts from "./Experts";

const Home = () => {
  return (
   <>
   <Hero/>
   <Service/>
   <Experts/>
   </>
  );
};

export default Home;
